import { useAtomValue, useSetAtom } from "jotai";
import { useCallback } from "react";
import {
  promotionAppliedDeductionsCountAtom,
  promotionAppliedDeductionsCurrentPageAtom,
  promotionAppliedDeductionsErrorAtom,
  promotionAppliedDeductionsHasFetchedAtom,
  promotionAppliedDeductionsIsLoadingAtom,
  promotionAppliedDeductionsIsRefreshingAtom,
  promotionAppliedDeductionsListAtom,
  promotionAppliedDeductionsPageLimitAtom,
  promotionAppliedDeductionsTotalAmountAtom,
  promotionAppliedDeductionsTotalClaimedAtom,
  resetPromotionAppliedDeductionsAtom,
} from "@/store/promotion/promotionAppliedDeductions.atoms";
import {
  getPromoDeductionApplySummaryAtom,
  setPromotionAppliedDeductionsCurrentPageAtom,
} from "@/store/promotion/promotionAppliedDeductions.actions";

interface GetPromoDeductionApplySummaryParams {
  promoEventId: number;
  isLoading?: boolean;
  isRefreshing?: boolean;
}

export function usePromotionAppliedDeductions() {
  const items = useAtomValue(promotionAppliedDeductionsListAtom);
  const isLoading = useAtomValue(promotionAppliedDeductionsIsLoadingAtom);
  const isRefreshing = useAtomValue(promotionAppliedDeductionsIsRefreshingAtom);
  const error = useAtomValue(promotionAppliedDeductionsErrorAtom);
  const currentPage = useAtomValue(promotionAppliedDeductionsCurrentPageAtom);
  const pageLimit = useAtomValue(promotionAppliedDeductionsPageLimitAtom);
  const count = useAtomValue(promotionAppliedDeductionsCountAtom);
  const hasFetched = useAtomValue(promotionAppliedDeductionsHasFetchedAtom);
  const totalDeductionsClaimed = useAtomValue(promotionAppliedDeductionsTotalClaimedAtom);
  const totalDeductionsAmount = useAtomValue(promotionAppliedDeductionsTotalAmountAtom);

  const getPromoDeductionApplySummaryAction = useSetAtom(getPromoDeductionApplySummaryAtom);
  const setCurrentPage = useSetAtom(setPromotionAppliedDeductionsCurrentPageAtom);
  const resetAppliedDeductions = useSetAtom(resetPromotionAppliedDeductionsAtom);

  const getPromoDeductionApplySummary = useCallback(
    (params: GetPromoDeductionApplySummaryParams) => getPromoDeductionApplySummaryAction({ ...params }),
    [getPromoDeductionApplySummaryAction]
  );

  return {
    items,
    isLoading,
    isRefreshing,
    error,
    currentPage,
    pageLimit,
    count,
    hasFetched,
    totalDeductionsClaimed,
    totalDeductionsAmount,
    setCurrentPage,
    getPromoDeductionApplySummary,
    resetAppliedDeductions,
  };
}

export type { GetPromoDeductionApplySummaryParams };
